export default {
  nav: {
    logo: "CC",
    links: [
      { text: "Work", to: "mywork" },
      { text: "Contact", to: "mycontact" },
    ],
  },
  header: {
    img: process.env.PUBLIC_URL + "/assets/ines.jpeg",
    text: ["Hi!", "I'am Ines.", " And I am "],
    typical: [
      "a full stack developer. 🖥",
      2000,
      "a front end developer  🖥 ",
      2000,
      " a back end developer 🖥",
      2000,
    ],
    typical2: [
      "A Life Lover",
      2000,
      "A Code Lover 🖥️",
      2000,
      "And A Music Lover 🎵",
      2000,
      "Catch Me If You Can! 🤺",
      2000,
    ],
    typical3: ["I Have Done", 2000, "I Have Done.. ", 2000],
    btnText: "Discover More",
  },
  work: [
    {
      img: process.env.PUBLIC_URL + "/assets/tunisian.png",

      projectName: "Tunisian fann",
      desc:
        "Used the SCRUM methodology, I was responsible, as a product owner, for defining stories and prioritizing the product backlog to streamline the execution of program priorities. I also developed a client interface using vue and vuex. on top of that I added an online payment thanks to the Konnect API. I also modelled the application with Sequelize. I Secured the application with an authentication system using jwt. I finally documented APIs using Swagger and Swagger-jsdoc.",
      link: "https://github.com/The-angry-birds",
    },
    {
      img: process.env.PUBLIC_URL + "/assets/catwalk.jpeg",

      projectName: "Catwalk",
      desc:
        "Made a design template that meets the customer requirements. Maintained the product backlog as a product owner and participated in team demo and retrospective. Used the service oriented architecture (SOA) as a type of software design. Technologies: React, MySql,Express, JWT, DigitalOcean.",
      link: "https://github.com/Ksou7",
    },
    {
      img: process.env.PUBLIC_URL + "/assets/logo.png",

      projectName: "Tyrebox",
      desc:
        "Realization of a web application that allows the user to consult the prices of tires in stock. I used the SCRUM methodology. Product owner. Technologies used:React, Node.js, express, Mysql, JSON Web Token (JWT), Bootstrap.",
      link: "https://github.com/TyreBox-XL-mation",
    },
  ],
  stack: {
    title: "Stack",
    tech: [
      {
        img: process.env.PUBLIC_URL + "/logo512.png",
        alt: "react",
      },
      {
        img: process.env.PUBLIC_URL + "/assets/vue.png",
        alt: "vue",
      },
      {
        img: process.env.PUBLIC_URL + "/assets/tailwindcss.svg",
        alt: "vue",
      },

      {
        img: process.env.PUBLIC_URL + "/assets/node.png",
        alt: "node",
      },

      {
        img: process.env.PUBLIC_URL + "/assets/express.png",
        alt: "express",
      },

      {
        img: process.env.PUBLIC_URL + "/assets/mongo.png",
        alt: "mongodb",
      },
      {
        img: process.env.PUBLIC_URL + "/assets/mysql.png",
        alt: "mysql",
      },
      {
        img: process.env.PUBLIC_URL + "/assets/sequelize.svg",
        alt: "mysql",
      },
    ],
    desc: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only`,
  },
  contact: {
    title: "Contact Me!",
    desc:
      "I Hope that you enjoyed the adventure and that you got to know me a little bit. In the section below you'll be able to contact me . Click on the Icons and you'll be redirected! Feel free to check my work on Github!    ",
    socials: [
      {
        alt: "github",
        img: process.env.PUBLIC_URL + "/assets/github.png",
        href: "https://github.com/inespiazzese",
      },
      {
        alt: "link",
        img: process.env.PUBLIC_URL + "/assets/link.png",
        href: "https://www.linkedin.com/in/ines-pia/",
      },
    ],
    img: process.env.PUBLIC_URL + "/assets/ines.jpeg",
  },
};
